// Footer Component - Mobile Optimized
const Footer = () => {
  return (
    <footer className="py-8 sm:py-12 px-4 border-t border-[#c9a962]/10" data-testid="footer">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-6">
          <div className="flex items-center gap-2 sm:gap-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_b5bd5f4a-d504-46bf-ad61-768b78dda5bc/artifacts/kjapaj5e_image.png" 
              alt="Transfer del Sur Logo" 
              className="w-7 h-7 sm:w-8 sm:h-8 rounded-full object-cover"
            />
            <span className="text-xs sm:text-sm text-gray-400 text-center sm:text-left">
              © 2024 <span className="notranslate">Transfer del Sur Costa del Sol</span>
            </span>
          </div>

          <div className="flex items-center gap-6">
            <a
              href="https://instagram.com/transferdelsur"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#c9a962] transition-colors"
              aria-label="Instagram"
            >
              <i className="fab fa-instagram text-xl"></i>
            </a>
            <a
              href="https://wa.me/34600221794"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#c9a962] transition-colors"
              aria-label="WhatsApp"
            >
              <i className="fab fa-whatsapp text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
